import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { useReplies } from '../../_load/ServiceOrderLoader'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  getRepliesFromBlockQuestion,
  getReplyValue
} from '../../_helpers/pdfHelpers'

const ShippingLocations = () => {
  const replies = useReplies()

  const shippingLocationsBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 379)
    const shippingLocationsReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const shippingLocationsResult = {}
    shippingLocationsReplies.forEach(shippingLocationsReply => {
      const blockIndex = shippingLocationsReply.blockIndex
      let shippingLocationsData = shippingLocationsResult[blockIndex]
      if (!shippingLocationsData) {
        const blockReplies = getRepliesFromBlockQuestion(shippingLocationsReplies, blockIndex)

        shippingLocationsData = {
          locationNumber: getReplyValue(findReplyByQuestionId(blockReplies, 380)),
          street: getReplyValue(findReplyByQuestionId(blockReplies, 381)),
          city: getReplyValue(findReplyByQuestionId(blockReplies, 382)),
          state: getReplyValue(findReplyByQuestionId(blockReplies, 383)),
          zip: getReplyValue(findReplyByQuestionId(blockReplies, 384)),
          country: getReplyValue(findReplyByQuestionId(blockReplies, 385))
        }
        shippingLocationsResult[blockIndex] = shippingLocationsData
      }
    })
    return Object.values(shippingLocationsResult)
  }
  const shippingLocationsData = shippingLocationsBlock()

  return (
    <>
      <Text bold size="h5">
        Shipping Locations
      </Text>
      <Separator weight={5} />
      <Table width="100%" fixedLayout useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Location Number</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Street</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>City</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>State</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Zip</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Country</Text>
          </TableCol>
        </TableRow>
        {shippingLocationsData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.locationNumber}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.street}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.city}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.state}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.zip}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.country}</Text>
            </TableCol>
          </TableRow>
        ))}
      </Table>
    </>
  )
}

export default ShippingLocations
